/* eslint-disable no-unused-vars */
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
  Thumbs,
} from "swiper/modules";
// import Swiper and modules styles

export default function initSliders() {
  const metaHeadingEl = document.querySelector(".case-study-slider__meta");

  function setMetaFrom(e) {
    const slideEl = e.slides[e.realIndex];
    if (slideEl && slideEl.dataset.meta) {
      metaHeadingEl.textContent = slideEl.dataset.meta;
    } else {
      metaHeadingEl.textContent = "";
    }
  }

  const casestudiesSlider = new Swiper(".case-study-slider__slides-wrapper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1.2,
    spaceBetween: 16,
    //centeredSlides: false,
    loop: true,

    breakpoints: {
      560: {
        slidesPerView: 1.5,
        spaceBetween: 32,
      },
      800: {
        slidesPerView: "1.5",
        spaceBetween: 32,
      },
    },
    wrapperClass: "case-study-slider__slides",
    slideClass: "case-study-slider__slide",
    navigation: {
      nextEl: ".case-study-slider__navigation__button--next",
      prevEl: ".case-study-slider__navigation__button--prev",
    },
    pagination: {
      el: ".case-study-slider__pagination",
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`;
      },
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    on: {
      init(swiper) {
        setMetaFrom(swiper);

        // Pause autoplay on hover, resume on leave
        const sliderEl = swiper.el;
        sliderEl.addEventListener("mouseenter", () => {
          swiper.autoplay.stop();
        });
        sliderEl.addEventListener("mouseleave", () => {
          swiper.autoplay.start();
        });
      },
      realIndexChange(swiper) {
        setMetaFrom(swiper);
      },
    },
  });

  const statsSlider = new Swiper(".stats-slider__slides-wrapper", {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
      },
      320: {
        slidesPerView: 2.1,
        spaceBetween: 20,
      },
      500: {
        slidesPerView: 3.1,
        spaceBetween: 20,
      },
      900: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
    wrapperClass: "stats-slider__slides",
    slideClass: "stats-slider__slide",
    // pagination: {
    //   el: ".stats-slider__pagination",
    //   type: "fraction",
    //   renderFraction(c, t) {
    //     return `<span class="${c}"></span> / <span class="${t}"></span>`;
    //   },
    // },
  });

  const timelineSlider = new Swiper(".timeline-slider__slides-wrapper", {
    slidesPerView: "auto",
    // spaceBetween: 16,
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 16,
      },
      320: {
        slidesPerView: 1.3,
        spaceBetween: 72,
      },
      500: {
        slidesPerView: 2.3,
        spaceBetween: 72,
      },
      900: {
        slidesPerView: 4,
        spaceBetween: 48,
      },
    },
    wrapperClass: "timeline-slider__slides",
    slideClass: "timeline-slider__slide",
    // pagination: {
    //   el: ".timeline-slider__pagination",
    //   type: "fraction",
    //   renderFraction(c, t) {
    //     return `<span class="${c}"></span> / <span class="${t}"></span>`;
    //   },
    // },
  });

  // console.log(casestudiesSlider);

  // const quotesSwiper = new Swiper(".quotes-slider", {
  //   modules: [Navigation, Pagination],
  //   slidesPerView: 1,
  //   // loop: true,
  //   // lazy: true,
  //   //effect: 'fade',
  //   spaceBetween: 0,
  //   // autoplay: {
  //   //   delay: 3500,
  //   //   disableOnInteraction: false,
  //   // },
  //   wrapperClass: "quotes-slider__slides",
  //   slideClass: "quotes-slider__slide",
  //   pagination: {
  //     el: ".quotes-slider__pagination",
  //     clickable: true,
  //     type: "bullets",
  //     bulletActiveClass: "quotes-slider__pagination__bullet--active",
  //     bulletClass: "quotes-slider__pagination__bullet",
  //     bulletElement: "div",
  //   },
  //   navigation: false,
  // });
}
